import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, ImageBackground, Animated, Easing, Platform } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
}

export class SurpriseTaskPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };
  render() {
    const { onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <ImageBackground
                style={styles.luckyUser}
                resizeMode={'stretch'}
                source={require('../../images/invite/imageTip.png')}
              />
              <EmTouchableOpacity
                style={{
                  marginTop: rpx(275),
                }}
                onPress={() => {
                  onPress && onPress();
                  this.hide();
                }}
              >
                <ImageBackground
                  style={styles.getAwardCount}
                  resizeMode={'stretch'}
                  source={require('../../images/invite/getChance.png')}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -rpx(50),
    overflow: 'hidden',
  },
  luckyUser: {
    position: 'absolute',
    marginTop: -rpx(30),
    width: rpx(300),
    height: rpx(394),
  },
  getAwardCount: {
    marginTop: rpx(10),
    width: rpx(210),
    height: rpx(51),
  },
});
